import { render, staticRenderFns } from "./SubscriptionEditor.vue?vue&type=template&id=22db57da&scoped=true"
import script from "./SubscriptionEditor.vue?vue&type=script&lang=js"
export * from "./SubscriptionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db57da",
  null
  
)

export default component.exports